<div class="soon-card">
  <h5 class="soon-card__header body-1">{{ item?.header }}</h5>
  <button class="soon-card__button" mat-flat-button [routerLink]="item?.url">{{ item?.buttonName | translate }}</button>
</div>
